module.exports = __webpack_public_path__ + "img/SWP_Shield_02 (2).7b58505a.png";